import React, { useState } from "react";
import { getCardImage } from "../../resultVisuals/cardAssets";
import CardImg from "../../../../components/CardImg";

/**
 * V VIP Teenpatti 1-day (teen62) video card overlay — reference markup:
 * .casino-video-cards[.hide-cards] > .casino-cards-shuffle (toggles the cards) + .casino-video-cards-container
 * (h4 Player A, cards[0,2,4], h4 Player B, cards[1,3,5]). Rendered whenever the round has a card string;
 * collapsed (.hide-cards) while the first card is still "1" or after the shuffle icon is clicked.
 */
export default function Teen62CardsOverlay({ cardString }) {
  const [showCards, setShowCards] = useState(true);
  const cards = String(cardString || "").split(",").map((c) => c.trim());
  if (!cardString || !cards.length) return null;

  const hidden = !showCards || cards[0] === "1";

  if (cards[0] === "1" && !showCards) setShowCards(true); // new round re-opens a hand-closed strip
  const renderCards = (idx) =>
    idx.map((i, k) => (
      <React.Fragment key={i}>
        {k > 0 ? " " : null}
        <span>
          <CardImg src={getCardImage(cards[i])} alt="" />
        </span>
      </React.Fragment>
    ));

  return (
    <div className={hidden ? "casino-video-cards hide-cards" : "casino-video-cards"}>
      <div className="casino-cards-shuffle" onClick={() => cards[0] !== "1" && setShowCards((v) => !v)}>
        <i className="fas fa-grip-lines-vertical" />
      </div>{" "}
      <div className="casino-video-cards-container">
        <h4 className="text-left text-white text-uppercase">Player A</h4>{" "}
        <div>{renderCards([0, 2, 4])}</div>{" "}
        <h4 className="text-left text-white text-uppercase">Player B</h4>{" "}
        <div>{renderCards([1, 3, 5])}</div>
      </div>
    </div>
  );
}
